import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { formatNumber } from "@/utils/format";

export default function HeroSection() {
  const featured = topics[0];
  const hotFive = topics.slice(0, 5);
  const totalVotes = topics.reduce((sum, t) => sum + t.poll.totalVotes, 0);
  const totalComments = topics.reduce((sum, t) => sum + t.commentCount, 0);
  const totalFollow = topics.reduce((sum, t) => sum + t.followers, 0);

  const stats = [
    { label: "在榜话题", value: `${topics.length} 条`, icon: "ri-fire-line" },
    { label: "累计投票", value: formatNumber(totalVotes), icon: "ri-bar-chart-2-line" },
    { label: "网友讨论", value: `${formatNumber(totalComments)} 条`, icon: "ri-chat-3-line" },
    { label: "关注用户", value: formatNumber(totalFollow), icon: "ri-user-heart-line" },
  ];

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 pb-10 pt-8 md:px-8 md:pb-14 md:pt-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 font-label text-xs text-primary-700">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-radar-line" aria-hidden="true" />
            </span>
            爆料看点 · 吃瓜风向站
          </div>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-5xl">
            看懂热搜背后的
            <span className="text-primary-600">评论区风向</span>
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            这里把争议事件的来龙去脉、评论区高能回复、网友神评论和投票结果摆在同一张页面上。
            遇到看不懂风向的话题，先看态度分布，再看大家在吵什么，一分钟就能完成站队前的功课。
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/topics"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-fire-line" aria-hidden="true" />
              </span>
              看今日热榜
            </Link>
            <Link
              to="/polls"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-secondary-300 hover:bg-secondary-50 hover:text-secondary-800"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-bar-chart-2-line" aria-hidden="true" />
              </span>
              看投票风向
            </Link>
          </div>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-7">
            <Link
              to={`/topics/${featured.id}`}
              className="group relative block h-[300px] cursor-pointer overflow-hidden rounded-lg bg-foreground-900 md:h-[400px]"
              aria-label={featured.title}
            >
              <img
                src={featured.cover}
                alt={`${featured.title} 话题封面`}
                title={`${featured.title} - 爆料看点`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/5" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 font-label text-xs text-background-50">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-flashlight-fill" aria-hidden="true" />
                  </span>
                  焦点话题
                </span>
                <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                  {featured.title}
                </h2>
                <p className="mt-2 line-clamp-2 max-w-2xl text-sm leading-relaxed text-background-200">
                  {featured.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs text-background-200">
                  <span className="inline-flex items-center gap-1">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-fire-line" aria-hidden="true" />
                    </span>
                    {formatNumber(featured.heat)} 热度
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-chat-3-line" aria-hidden="true" />
                    </span>
                    {formatNumber(featured.commentCount)} 条讨论
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-background-50/20 px-2.5 py-1">
                    {featured.readTime}
                  </span>
                </div>
              </div>
            </Link>
          </div>

          <div className="lg:col-span-5">
            <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between gap-3">
                <h2 className="font-heading text-base font-bold text-foreground-950">
                  今日热榜 TOP 5
                </h2>
                <span className="font-label text-xs text-foreground-500">每小时更新</span>
              </div>
              <ol className="mt-3 flex-1 divide-y divide-background-200">
                {hotFive.map((topic, index) => (
                  <li key={topic.id}>
                    <Link
                      to={`/topics/${topic.id}`}
                      className="group flex cursor-pointer items-start gap-3 py-3"
                    >
                      <span
                        className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                          index === 0
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                          {topic.title}
                        </span>
                        <span className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 font-label text-xs text-foreground-500">
                          <span className="text-secondary-700">{topic.category}</span>
                          <span>{formatNumber(topic.heat)} 热度</span>
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
              <Link
                to="/topics"
                className="mt-3 inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
              >
                查看完整榜单
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </Link>
            </div>
          </div>
        </div>

        <dl className="mt-8 grid grid-cols-2 gap-4 border-t border-background-200 pt-6 md:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                <i className={`${stat.icon} text-lg`} aria-hidden="true" />
              </span>
              <span className="min-w-0">
                <dt className="font-label text-xs text-foreground-500">{stat.label}</dt>
                <dd className="font-heading text-lg font-bold text-foreground-950">{stat.value}</dd>
              </span>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}